import List from '../../common/List';
import UserRow from './Row';
import {useLocation} from 'react-router-dom';
import routes from '../routes';
import {UserListProps} from '../../../constants/types';

const UsersList = () => {
  const {pathname} = useLocation();
  const isSysConfPath = pathname.includes(routes.users());

  return (
    <List
      rowRenderer={(content) => content.map((user: UserListProps) => (
        <UserRow
          key={`${user.id}`}
          user={user}
          isSysConfPath={isSysConfPath}
        />
      ))}
    />
  );
};

export default UsersList;
